import { usePublicSiteData } from "./PublicSiteContext";
import { StageImage, useStage } from "./StagedImageLoading";

const PublicGallery = () => {
  const website = usePublicSiteData();
  const items = website?.beforeAfter ?? [];
  const beforeAfterCount = items.reduce(
    (n, it) => n + (it.beforeImageUrl ? 1 : 0) + (it.afterImageUrl ? 1 : 0),
    0,
  );
  useStage("beforeAfter", beforeAfterCount);

  return (
    <>
      <section className="psite-page-hero">
        <div className="psite-page-hero__inner">
          <h1>Gallery</h1>
          <p>See the results with before and after images.</p>
        </div>
      </section>

      <section className="psite-section">
        <div className="psite-section__inner">
          {items.length > 0 ? (
            <div className="psite-gallery">
              {items.map((item, i) => (
                <figure
                  className="psite-gallery__item"
                  key={`${item.beforeImageUrl}-${i}`}
                >
                  <div className="psite-gallery__pair">
                    <div className="psite-gallery__cell">
                      {item.beforeImageUrl ? (
                        <StageImage
                          stage="beforeAfter"
                          src={item.beforeImageUrl}
                          alt="Before"
                        />
                      ) : (
                        <span className="psite-gallery__placeholder">
                          Before
                        </span>
                      )}
                      <span className="psite-gallery__tag">Before</span>
                    </div>
                    <div className="psite-gallery__cell">
                      {item.afterImageUrl ? (
                        <StageImage
                          stage="beforeAfter"
                          src={item.afterImageUrl}
                          alt="After"
                        />
                      ) : (
                        <span className="psite-gallery__placeholder">
                          After
                        </span>
                      )}
                      <span className="psite-gallery__tag">After</span>
                    </div>
                  </div>
                  {item.title && (
                    <figcaption>{item.title}</figcaption>
                  )}
                </figure>
              ))}
            </div>
          ) : (
            <p className="psite-section__empty">
              Before / after images will appear here once published.
            </p>
          )}
        </div>
      </section>
    </>
  );
};

export default PublicGallery;